import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL, API_STATUS } from '../../constants/config';
import { CommonService } from '../common/common.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
@Injectable()
export class ApiService {

  constructor(private http: HttpClient, private _common: CommonService) { }

  getListState(keyword?) {
    const url = keyword ? `${API_URL}user/liststate?search=${keyword}` : `${API_URL}user/liststate`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  search(terms: Observable<string>) {
    return terms.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(term => this.getListCounty(term));
  }

  getListCounty(term) {
    const url = `${API_URL}marketing/list-county`;
    const data = { input: term };
    return new Promise((resolve, reject) => {
      this.http.post(url, data, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  searchListState(term) {
    const url = `${API_URL}marketing/list-state`;
    const data = { input: term };
    return new Promise((resolve, reject) => {
      this.http.post(url, data, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  getOwnCounties() {
    const url = `${API_URL}marketing/list-bought-county`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  addArea(data) {
    const url = `${API_URL}marketing/add-advertiser-county`;
    return new Promise((resolve, reject) => {
      this.http.post(url, data, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      }, () => {
        reject();
      });
    });
  }
  getCountyByUser() {
    const url = `${API_URL}marketing/advertiser-county`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        if (!res.success) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  reserveCounty(req) {
    const url = `${API_URL}marketing/reserve-county`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        // this._common.showToastr('success', `Thanks for reserving county. We'll contact you soon for advertising!`, '')
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  deleteArea(req) {
    const url = `${API_URL}marketing/delete-advertiser-county`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  getListReview(data) {
    const url = `${API_URL}marketing/list-review-advertiser`;
    return new Promise((resolve, reject) => {
      this.http.post(url, data, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  getListLeads(req) {
    const url = `${API_URL}marketing/list-leads`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  requestReview(req) {
    const url = `${API_URL}marketing/request-review`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  purchaseCounty(req) {
    const url = `${API_URL}marketing/advertiser-purchase-county`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
        // this._common.showToastr('success', res.Message, 'Purchase Status');
      }, (err) => {
        reject(err);
      });
    });
  }

  getListPackage() {
    const url = `${API_URL}marketing/list-county-package`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        console.log(res);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  // purchase package
  purchasePackage(req) {
    const url = `${API_URL}marketing/purchase-package`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        this._common.onChangeProfile.next('purchase package');
        resolve(res.Data);
        // this._common.showToastr('success', res.Message, 'Purchase Status');
      }, (err) => {
        reject(err);
      });
    });
  }
  // Add county (for enterprise package)
  addEnterpriseCounty(req){
    const url = `${API_URL}marketing/add-county-enterprise`;
    return new Promise((resolve, reject) => {
      this.http.post(url, req, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }
  cancelRenew(id){
    const req = {
      'id': id
    };
    const url = `${API_URL}marketing/cancel-renew`;
    return this.http.post(url, req);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api-service/api.service.ts